import React, { FC, Fragment, useCallback, useState, useMemo, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { TranslationsContext } from './translationsContext';
import { Translations, TranslationsProviderProps } from './translationsTypes';

export const TranslationsProvider: FC<TranslationsProviderProps> = ({ children, messages }) => {
  const [pageDirection, setPageDirection] = useState<'rtl' | 'ltr'>('rtl');
  const [language, setLanguageState] = useState(Translations.ar);

  const setLanguage = useCallback((language: Translations) => {
    localStorage.setItem('language', language);
    setLanguageState(language);
    if (language === Translations.ar) {
      setPageDirection('rtl');
    } else {
      setPageDirection('ltr');
    }
  }, []);

  useEffect(
    () => {
      const localLanguage = localStorage.getItem('language');
      if (localLanguage === 'en' || localLanguage === 'ar') {
        setLanguage(localLanguage as Translations);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const value = useMemo(
    () => ({ language, setLanguage, pageDirection }),
    [language, setLanguage, pageDirection]
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  return (
    <TranslationsContext.Provider value={value}>
      <div dir={pageDirection}>
        <IntlProvider
          defaultLocale={'en'}
          key={language}
          locale={language}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          textComponent={Fragment as any}
          messages={messages[language]}
        >
          {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            children as any
          }
        </IntlProvider>
      </div>
    </TranslationsContext.Provider>
  );
};
